import { teamAdapter } from "@store/teams/teams-slice";
import { RemoveTeamMembers, TeamState } from "@store/teams/teams-slice-types";
/** Stores how many members are returned from the backend per request. */
export const API_MEMBERS_PER_REQUEST = 30;

/**
 * Removes locally a member from a team, by removing it from sample members array
 * attribute of the team if members are available.
 */
export function removeLocalMemberFromTeam(
  state: TeamState,
  result: RemoveTeamMembers
): void {
  const team = teamAdapter.getSelectors().selectById(state, result.teamId);
  if (team) {
    const updatedMembers = state.selectedTeam.members;
    result.memberIds.forEach((memberId) => {
      delete updatedMembers[memberId];
    });

    state.selectedTeam.members = updatedMembers;
  }
}
